import React from 'react';
import Layout from '../Components/Layout/Layout';
import EditProfile from '../Components/Profile/EditProfile';

function EditProfilePage() {
  return (
    <Layout>
      <EditProfile />
    </Layout>
  );
}

export default EditProfilePage;
